import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { CouponDto } from './useListCoupons';

export type UserCouponDto = {
  id: string;
  coupon: CouponDto;
  usageCount: number;
  assignedAt: string;
  remainingUses: number;
};

export const GET_USER_COUPONS_QUERY_KEY = (userId: string) => ['user-coupons', userId];

export const useGetUserCoupons = (userId: string) => {
  const client = useApiClient();

  return useQuery({
    queryKey: GET_USER_COUPONS_QUERY_KEY(userId),
    queryFn: () =>
      client.fetchApi<UserCouponDto[], {}>({
        endpoint: `coupons/admin/user/${userId}`,
        method: 'GET',
      }),
    enabled: !!userId,
  });
};
